@let loading = isLoading;

<div class="worker-modal">
  <h2 class="worker-modal__title">
    {{ modalTitleTranslationKey | translate }}
  </h2>

  <form
    class="worker-modal__form"
    [formGroup]="workerForm"
    (ngSubmit)="submit()"
  >
    <section class="worker-modal__section">
      <h3 class="worker-modal__section-title">{{ dataSectionTitle }}</h3>

      <div class="worker-modal__grid">
        <lib-input
          class="worker-modal__field"
          formControlName="name"
          [label]="'monitoring.workers.modal.fields.name' | translate"
          [placeholder]="'monitoring.workers.modal.fields.name' | translate"
          [libSkeleton]="loading"
        />

        <lib-input
          class="worker-modal__field"
          formControlName="displayName"
          [label]="'monitoring.workers.modal.fields.display-name' | translate"
          [placeholder]="'monitoring.workers.modal.fields.display-name' | translate"
          [libSkeleton]="loading"
        />

        <mon-client-select
          class="worker-modal__field"
          formControlName="client"
          labelTranslateKey="monitoring.workers.modal.fields.client"
          [fullWidth]="true"
          [libSkeleton]="loading"
        />

        <mon-worker-status-select
          class="worker-modal__field"
          formControlName="status"
          labelTranslateKey="monitoring.workers.modal.fields.status"
          [fullWidth]="true"
          [libSkeleton]="loading"
        />

        <mon-pool-select
          class="worker-modal__field"
          formControlName="pool"
          labelTranslateKey="monitoring.workers.modal.fields.pool"
          [fullWidth]="true"
          [libSkeleton]="loading"
        />

        <mon-coin-select
          class="worker-modal__field"
          formControlName="coin"
          labelTranslateKey="monitoring.workers.modal.fields.coin"
          [fullWidth]="true"
          [libSkeleton]="loading"
        />
      </div>
    </section>

    <section class="worker-modal__section">
      <h3 class="worker-modal__section-title">{{ observerLinkSectionTitle }}</h3>

      <lib-input
        class="worker-modal__field worker-modal__field--observer"
        formControlName="observerLink"
        [label]="'monitoring.workers.modal.fields.observer-link' | translate"
        [placeholder]="'monitoring.workers.modal.fields.observer-link' | translate"
        [libSkeleton]="loading"
      />
    </section>

    <div class="worker-modal__actions">
      <lib-button
        buttonStyle="transparent-tertiary"
        type="button"
        [disabled]="loading"
        (click)="closeModal()"
      >
        {{ 'monitoring.workers.modal.actions.cancel' | translate }}
      </lib-button>

      <lib-button
        buttonStyle="primary"
        buttonType="submit"
        [disabled]="workerForm.invalid || loading"
      >
        {{ submitTranslationKey | translate }}
      </lib-button>
    </div>
  </form>
</div>
